/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Aceptarlas todas",
      "Utilizamos cookies para que nuestro sitio web funcione mejor. Estas incluyen cookies publicitarias y de análisis. Para más información, lee nuestra <a p0>Política de cookies</a>.",
      "Gestionar opciones",
      "Indícanos si aceptas las cookies",
      "Política de cookies",
      "Gestionar cookies",
      "(se abre en otra ventana)",
      "Migas de pan",
      "Inicio",
      "Pie de página",
      "© {{current_year}} Bumble Todos los derechos reservados",
      "Crea una cuenta",
      "Descargar la app",
      "Ayuda",
      "Prensa",
      "Privacidad",
      "Condiciones de Uso",
      "Página principal de {{partner}}",
      "Ofrecido por Bumble Inc",
      "Sobre nosotros",
      "Blog",
      "Empleo",
      "General",
      "Facebook",
      "Seguir",
      "Instagram",
      "Twitter",
      "Si alguna vez te sientes a disgusto, te encuentras con un comportamiento nocivo o simplemente necesitas consejo, estamos a tu lado. Visita nuestra variedad de guías para encontrar apoyo y consejos prácticos.",
      "Página principal del Safety Centre de {{partner}}",
      "La seguridad primero, segundo y siempre.",
      "Te damos la bienvenida a nuestro Safety Centre, mira este vídeo",
      "Más guías",
      "Cerrar menú",
      "Guías",
      "Ver líneas de ayuda anteriores",
      "Ver más líneas de ayuda",
      "Líneas de ayuda",
      "Principal",
      "Menú",
      "Abrir menú",
      "Herramientas",
      "Actualizaciones",
      "Volver atrás",
      "Prueba a actualizar tu navegador o vuelve a la página de inicio.",
      "Lo sentimos, no podemos encontrar la página que buscas.",
      "¿Aún necesitas ayuda?",
      "Usa otro término de búsqueda o <a href=\"{{feedback_url}}\" class=\"link\">contacta con nosotros</a>.",
      "Revisar la ortografía",
      "Usa términos genéricos y amplía los resultados",
      "Prueba con una búsqueda similar pero diferente",
      "No pares ahora. Aquí tienes algunos consejos:",
      "Quizás también te resulten útiles:",
      "Lo sentimos, no encontramos ningún resultado que coincida con tu búsqueda.",
      "Resultados de búsqueda",
      "Resultados de búsqueda para {{search_query}}",
      "Borrar búsqueda",
      "¿Cómo podemos ayudar?",
      "Buscar",
      "En Bumble no toleramos el mal rollo, el lenguaje ofensivo o el abuso. Nos tomamos muy en serio e investigamos cada denuncia por comportamientos abusivos.",
      "Cuidamos de ti y de nuestra comunidad. Por eso, si alguien te hace sentir incomodidad o inseguridad no dudes en denunciarlo y tomaremos las medidas necesarias.",
      "El contenido sexual no solicitado o no consentido no está bien. Queremos protegerte si alguien te envía una foto explícita, difuminándola y avisándote primero.",
      "Un catfish es alguien que utiliza un perfil falso para fingir ser otra persona. Engaña a la gente online. Si necesitas ayuda, estamos aquí para ayudarte.",
      "El acoso puede ser sexual o no sexual. Si alguien te acosa en Bumble o en la vida real, no dudes en ponerte en contacto con nosotros.",
      "¿Cita a la vista? ¡Genial! Te ayudamos con tu seguridad tanto en Bumble, como en la vida real. Así que, si ya tienes ganas de quedar, vamos a prepararte.",
      "Durante la covid, salir no era una opción. Quedar puede ser arriesgado, así que esto es lo que debes tener en cuenta antes de pasar de Bumble a la vida real.",
      "La primera cita debe ser divertida. Puede ser incómoda al principio, pero nunca insegura. Concéntrate en divertirte y mantén la seguridad con estos consejos.",
      "Sabemos que empezar (o retomarlo tras un descanso) puede ser abrumador, pero estamos para ayudarte. Aquí tienes algunas cosas que puedes hacer para adaptarte.",
      "Es fácil sentir agobio o desgaste durante las citas. Si sufres de agotamiento en las citas, te prometemos que no te pasa solo a ti.",
      "Cuando alguien traiciona tu confianza, puede resultar difícil recuperarla. Sabemos lo angustioso que es, así que estamos aquí para ayudarte.",
      "Si estás lidiando con sentimientos de rechazo, tenemos una lista estupenda de cosas que deberías recordar siempre.",
      "Bumble es un lugar de libertad, seguridad y diversión para cada miembro de nuestra comunidad. Estos son nuestros consejos para conocer gente con seguridad.",
      "La verificación te permite mostrar a tus posibles matches que eres una persona real. Descubre cómo conseguir la verificación aquí. Solo te llevará unos minutos.",
      "Las estafas en las citas existen, así que hay que estar alerta y vigilar lo que se comparte. Te damos algunos consejos para protegerte de posibles estafas.",
      "Antes de todo acto íntimo o sexual con otra persona, siempre se necesita el consentimiento claro y voluntario de ambas partes para practicar dicha actividad.",
      "Enviar un primer mensaje a alguien puede ser complicado. Tenemos un montón de consejos que puedes utilizar para que empecéis a hablar con buen pie.",
      "Nuestro centro de seguridad para citas online está diseñado para ayudarte a mantener la seguridad y el control de tu experiencia en Bumble. Consulta nuestras guías, herramientas y líneas de ayuda.",
      "Comportamiento abusivo | Safety Centre - Bumble",
      "Qué pasa cuando denuncio | Safety Centre - Bumble",
      "He recibido una foto explícita | Safety Centre - Bumble",
      "Perfiles falsos - Catfish | Safety Centre - Bumble",
      "Me están acosando | Safety Centre - Bumble",
      "Quedar en persona | Safety Centre - Bumble",
      "Quedar en persona: citas y Covid | Safety Centre - Bumble",
      "Mantener la seguridad en las citas | Safety Centre - Bumble",
      "Bienestar mental | Safety Centre - Bumble",
      "Ansiedad por citas y cómo superarla | Safety Centre - Bumble",
      "Alguien ha traicionado mi confianza | Safety Centre - Bumble",
      "Tengo pocos matches o respuestas | Safety Centre - Bumble",
      "Consejos para tener citas seguras | Safety Centre - Bumble",
      "Cómo funciona la verificación | Safety Centre - Bumble",
      "Mantenerte a salvo ante las estafas | Safety Centre - Bumble",
      "Pedir y dar consentimiento | Safety Centre - Bumble",
      "Iniciar bien una conversación | Safety Centre - Bumble",
      "Safety centre para citas online | Bumble",
      "Consíguelo en el App Store",
      "Disponible en Google Play",
      "Cerrar sección",
      "cerrar",
      "Mostrar más",
      "Hemos diseñado estas herramientas para ayudarte a mantener la seguridad y el control a lo largo de tu viaje por el mundo de las citas. Descubre cómo gestionar tu experiencia en Bumble.",
      "Para más consejos e información cualificada sobre tendencias en citas, sexualidad, soltería y mucho más, echa un vistazo a nuestros últimos artículos del blog.",
      "Nuestro Manual de seguridad",
      "Selección de idioma"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "días"
            ],
            "singular": [
                  "día"
            ]
      },
      "hour": {
            "plural": [
                  "horas"
            ],
            "singular": [
                  "hora"
            ]
      },
      "minute": {
            "plural": [
                  "minutos"
            ],
            "singular": [
                  "minuto"
            ]
      },
      "month": {
            "plural": [
                  "meses"
            ],
            "singular": [
                  "mes"
            ]
      },
      "second": {
            "plural": [
                  "segundos"
            ],
            "singular": [
                  "segundo"
            ]
      },
      "year": {
            "plural": [
                  "años"
            ],
            "singular": [
                  "año"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
